module.exports = __webpack_public_path__ + "img/Steal.9a0c27ce.png";